<template>
    <div>
        <base-input label="Name:" v-model="farm.name"></base-input>
        <base-input label="Description:" v-model="farm.description"></base-input>
        <base-input label="Phone:" v-model="farm.phone"></base-input>
        <base-input label="Email:" v-model="farm.email"></base-input>

        <form-address @onSetAddress="setFarmAddress" :address="farm.address"></form-address>

        <div class="form-group">
            <label class="form-control-label">Timezone:</label>
            <b-form-select v-model="farm.timezone" :options="timezones"></b-form-select>
        </div>
    </div>
</template>

<script>
import BaseAlert from '../BaseAlert.vue';
import { timezones } from '@/config/Time'
export default {
  name: 'form-farm',
  components: {
    BaseAlert
  },
  props: {
    farm: {
      type: Object,
      default: null,
      description: ''
    }
  },
  data() {
    return {
        timezones: timezones
    };
  },
  methods: {
      setFarmAddress(address) {
          this.farm.address = address
      }
  }
};
</script>
